module.exports = __webpack_public_path__ + "img/ico034.009ab6c1.svg";